"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MessageResolver = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _dompurify = _interopRequireDefault(require("dompurify"));
var _ApplicationContext = require("./ApplicationContext");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
// eslint-disable-next-line import/prefer-default-export
const MessageResolver = _ref => {
  let {
    statusCode,
    message,
    customMessageResolver,
    defaultMessage,
    customMessage,
    context
  } = _ref;
  const investorServicesPhoneNumber = _ApplicationContext.ApplicationContext.getApplicationPreference('investorServicesPhoneNumber');
  const investorServicesLabel = _ApplicationContext.ApplicationContext.getApplicationPreference('investorServicesLabel');
  if (customMessageResolver) {
    const resolvedMessage = customMessageResolver({
      statusCode,
      message,
      context
    });
    if (resolvedMessage) {
      return resolvedMessage;
    }
  }
  if (message && /locked/.test(message)) {
    let msg = message;
    msg = msg.replace('{Investor-Services-Label}', investorServicesLabel);
    msg = msg.replace('{Investor-Services-Phone-Number}', investorServicesPhoneNumber);
    if (/unlock.html/.test(msg)) {
      // eslint-disable-next-line react/no-danger
      return /*#__PURE__*/_react.default.createElement("div", {
        dangerouslySetInnerHTML: {
          __html: _dompurify.default.sanitize(msg)
        }
      });
    }
    return msg;
  }
  if (statusCode === 418) {
    return 'Your account has been temporarily locked.  Please try again later.';
  }
  if (statusCode === 404) {
    return 'Unfortunately the document you requested cannot be located. You may try to verify the URL for proper spelling, or you may try one of the destinations below:';
  }
  return customMessage || message || defaultMessage;
};
exports.MessageResolver = MessageResolver;
MessageResolver.propTypes = {
  statusCode: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.string]),
  message: _propTypes.default.oneOfType([_propTypes.default.arrayOf(_propTypes.default.node), _propTypes.default.node, _propTypes.default.string]),
  customMessageResolver: _propTypes.default.oneOfType([_propTypes.default.arrayOf(_propTypes.default.node), _propTypes.default.node, _propTypes.default.func]),
  defaultMessage: _propTypes.default.oneOfType([_propTypes.default.arrayOf(_propTypes.default.node), _propTypes.default.node, _propTypes.default.string]),
  customMessage: _propTypes.default.oneOfType([_propTypes.default.arrayOf(_propTypes.default.node), _propTypes.default.node, _propTypes.default.string]),
  context: _propTypes.default.oneOfType([_propTypes.default.arrayOf(_propTypes.default.node), _propTypes.default.node, _propTypes.default.string, _propTypes.default.object])
};
//# sourceMappingURL=MessageResolver.js.map